import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { setIdentityUnverifiedCallback } from "../api/client";
import { getIdentityVerificationPath } from "../lib/identityVerification";
import { showToast } from "./ui/toastHotSonner";

/**
 * Intercepteur global pour les 403 `IDENTITE_NON_VERIFIEE` (compte non validé) — voir
 * doc FRONTEND restriction sous validation de compte. Sur réception, affiche un toast
 * et redirige vers la page de vérification d'identité du profil actif. Ne fait rien sur
 * les endpoints qui gèrent déjà ce cas en contexte (voir `skipIdentityUnverifiedHandling`).
 */
export default function IdentityVerificationGate() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathnameRef = useRef(location.pathname);
  const handledForPathRef = useRef<string | null>(null);

  useEffect(() => {
    pathnameRef.current = location.pathname;
    handledForPathRef.current = null;
  }, [location.pathname]);

  useEffect(() => {
    setIdentityUnverifiedCallback((message) => {
      const pathname = pathnameRef.current;
      const target = getIdentityVerificationPath(pathname);
      if (!target || pathname === target || handledForPathRef.current === pathname) return;
      handledForPathRef.current = pathname;
      showToast(message || "Votre compte doit être vérifié pour effectuer cette action.", "error");
      navigate(target);
    });
  }, [navigate]);

  return null;
}
